import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { Email, Fill } from './LegalLayout';
import { OWNER } from '../../config/legal';
import { FULL_REPORT_PRICE, FULL_REPORT_TAX_NOTE } from '../../config/pricing';
import { PAYMENTS_LIVE } from '../../config/payments';

// Terms of sale of the full report. The withdrawal clause follows art. 103.m
// TRLGDCU (digital content supplied at once with the buyer's express
// consent); the same notice is shown on Stripe's payment page (ai-checkout).
const Condiciones = () => (
  <LegalLayout
    title="Condiciones de venta"
    intro="Las condiciones del informe completo de webspector. Las hemos escrito para que se entiendan: si algo no está claro, pregúntanos."
  >
    {!PAYMENTS_LIVE && (
      <p className="rounded-2xl border border-[var(--lp-lime)] px-5 py-4 text-[var(--lp-text)]">
        La web está en pruebas: los pagos se hacen en el modo de prueba de Stripe y no se cobra nada.
      </p>
    )}

    <h2>Quién vende</h2>
    <p>
      <Fill value={OWNER.name} label="nombre y apellidos" />, NIF <Fill value={OWNER.nif} label="NIF" />,{' '}
      <Fill value={OWNER.address} label="domicilio" />. Contacto: <Email />.
    </p>

    <h2>Qué compras</h2>
    <p>
      Un informe de visibilidad en inteligencia artificial (informe GEO) de un negocio, que se genera automáticamente
      al pagar. Incluye:
    </p>
    <ul>
      <li>12 preguntas como las que haría un cliente, respondidas por una IA con búsqueda web en tiempo real.</li>
      <li>En qué porcentaje de respuestas aparece el negocio y cada competidor, y en qué puesto.</li>
      <li>Qué webs consulta la IA y qué ve en la web del negocio.</li>
      <li>Por qué la IA recomienda a otros, con las pruebas en las que se basa.</li>
      <li>Un plan de acción ordenado por impacto y los textos listos para aplicarlo.</li>
    </ul>
    <p>
      Puedes ver un <Link to="/informe/ejemplo">informe de ejemplo</Link> antes de comprar.
    </p>

    <h2>Precio y pago</h2>
    <p>
      {FULL_REPORT_PRICE} ({FULL_REPORT_TAX_NOTE}) por informe. Es un pago único: no hay suscripción ni cargos
      posteriores. Se paga con tarjeta a través de Stripe, que procesa el pago de forma segura; nosotros no vemos ni
      guardamos los datos de tu tarjeta. Si necesitas factura, pídenosla en <Email />.
    </p>

    <h2>Entrega</h2>
    <p>
      El informe empieza a prepararse en cuanto se confirma el pago y suele estar listo en uno o dos minutos. Lo ves en
      una página propia con un enlace privado: guárdalo, porque es tu forma de volver a él. Puedes descargarlo en PDF.
    </p>

    <h2>Desistimiento</h2>
    <p>
      El informe es contenido digital que preparamos y te entregamos en el momento. Por eso, al pagar das tu
      consentimiento expreso para que empecemos a prepararlo de inmediato y reconoces que, una vez empezado, pierdes el
      derecho de desistimiento de 14 días (artículo 103.m de la Ley General para la Defensa de los Consumidores y
      Usuarios). Si compras como empresa o profesional, el derecho de desistimiento no se aplica.
    </p>

    <h2>Si algo sale mal</h2>
    <ul>
      <li>
        Si el informe no llega a generarse, desde su página puedes volver a intentarlo sin pagar de nuevo.
      </li>
      <li>Si después de varios intentos no conseguimos generarlo, te devolvemos el importe completo.</li>
      <li>
        Para cualquier otra incidencia o reclamación, escríbenos a <Email /> y te responderemos lo antes posible.
      </li>
    </ul>

    <h2>Qué no garantizamos</h2>
    <p>
      El informe refleja lo que respondió la IA el día en que se hizo. Las respuestas de la IA cambian con el tiempo y
      cada asistente responde a su manera, así que no garantizamos que tu negocio vaya a aparecer en las
      recomendaciones de ningún asistente después de aplicar el plan. Lo que sí garantizamos es que el informe se basa
      en respuestas reales, obtenidas como se explica en él.
    </p>

    <h2>Códigos de invitación</h2>
    <p>
      A veces regalamos códigos que desbloquean un informe sin pagar. Son de un solo uso, personales y no se pueden
      cambiar por dinero. Si el informe falla, el código se puede volver a usar.
    </p>

    <h2>Seguimiento mensual (en pruebas)</h2>
    <p>
      Todavía no está a la venta. Con un código de prueba se activa gratis para el negocio de un informe durante el
      tiempo que indica el código. Mientras dure:
    </p>
    <ul>
      <li>
        Cada mes hacemos un informe nuevo del negocio con el mismo método: 12 preguntas como las que haría un cliente,
        respondidas por la IA ese día.
      </li>
      <li>
        Te enviamos por email si la IA te recomienda más o menos que el mes anterior, quién te ha adelantado y tu
        siguiente paso, con el enlace al informe completo.
      </li>
      <li>Puedes darte de baja cuando quieras con el enlace de cualquiera de los emails.</li>
      <li>Al terminar la prueba se acaba solo: no se cobra nada ni se renueva.</li>
    </ul>
    <p>
      Cada informe mensual hace pocas preguntas, así que cambios pequeños de un mes a otro pueden ser casualidad; el
      email te lo indica cuando es así.
    </p>

    <h2>Ley aplicable</h2>
    <p>
      Estas condiciones se rigen por la ley española. Si eres consumidor, puedes reclamar ante los juzgados de tu
      domicilio y ante los servicios de consumo de tu comunidad autónoma.
    </p>
  </LegalLayout>
);

export default Condiciones;
